import { Link, NavLink } from 'react-router-dom';
import { legalLinks } from '@/content/legal';

export const GlobalFooter = () => (
  <footer data-testid="site-footer" className="relative border-t border-surface-800 px-4 py-10 sm:px-8">
    <div className="mx-auto flex max-w-7xl flex-col gap-6 md:flex-row md:items-start md:justify-between">
      <div>
        <Link data-testid="footer-home-link" to="/" className="font-display text-lg font-bold text-copy-200 transition-colors hover:text-cyan-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-cyan-400">ClippedUp</Link>
        <p data-testid="footer-copyright" className="mt-2 text-sm text-copy-400">© {new Date().getFullYear()} ClippedUp · Turn long-form into viral shorts.</p>
      </div>
      <div className="space-y-3">
        <nav aria-label="Footer legal documents" data-testid="footer-legal-navigation" className="flex flex-wrap gap-x-6 gap-y-3 text-sm">
          {legalLinks.map(({ id, path, label }) => <NavLink key={id} data-testid={`footer-${id}-link`} to={path} className={({ isActive }) => `rounded-sm underline-offset-4 transition-colors hover:text-cyan-400 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-cyan-400 ${isActive ? 'text-cyan-400 underline' : 'text-copy-300'}`}>{label}</NavLink>)}
        </nav>
        <p data-testid="footer-draft-notice" className="text-xs text-copy-400">Public drafts · Under review, not effective policies</p>
      </div>
    </div>
  </footer>
);
